var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLeftThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87332 15.9305C9.15345 15.7898 9.26951 15.4362 9.12544 15.1777C9.08942 15.1131 7.6127 13.5657 5.84784 11.737C4.08298 9.91212 2.55424 8.31914 2.45419 8.20129L2.26609 7.98458L2.36214 7.87053C2.41017 7.8097 3.93891 6.22813 5.7558 4.35001C7.57268 2.4757 9.07742 0.90553 9.10543 0.859908C9.26551 0.578571 9.16146 0.209791 8.88132 0.0767259C8.64921 -0.0373297 8.48113 -0.0259241 8.26102 0.122348C8.16097 0.18698 6.53618 1.83698 4.65126 3.77973C2.76234 5.72628 1.14555 7.39529 1.0495 7.49034C0.813386 7.73366 0.761361 7.92755 0.86141 8.19368C0.925441 8.37237 1.30563 8.77917 4.50719 12.0754C6.46814 14.098 8.16097 15.8126 8.26102 15.881C8.47312 16.0217 8.66121 16.0369 8.87332 15.9305Z",
    fill: "#34A9FF",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLeftThin);
export default __webpack_public_path__ + "static/media/blue-left-thin.f606d5d59acd2b4419466f5b02d5dcf9.svg";
export { ForwardRef as ReactComponent };